import Button from "@mui/material/Button";

import styled from "styled-components";

const MOBILE = "768px";

/* ── Main Container ── */
export const FilterArea = styled.div`
    display: inline-block;
    width: 100%;
    height: auto;
    margin: 25px 0;

    &.is-wizard {
        margin: 0;
    }

    &.is-wizard .filter-list-wrapper .row {
        width: 100%;
        max-width: 100%;
        margin: 0 !important;
    }

    &.is-wizard .filter-list-wrapper .filter-list-item {
        width: 100%;
        max-width: 100%;
        min-width: 0;
    }

    @media (max-width: ${MOBILE}) {
        margin: 15px 0;
    }
`;

/* ── Header ── */
export const FilterHeader = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 20px;

    & > .filter-header-main {
        flex: 1;
        min-width: 0;
    }

    & .filter-section-title {
        color: #000000;
        font-weight: 600;
        font-size: 16px;
        display: block;
    }

    & > a {
        padding: 10px;
    }

    @media (max-width: ${MOBILE}) {
        margin-bottom: 14px;
        flex-wrap: wrap;
    }
`;

/* ── Filter List (the bordered box) ── */
export const FilterListWrapper = styled.div`
    background: white;
    border: 1px solid rgba(0, 0, 0, 0.05);
    border-radius: 10px !important;
    -webkit-border-radius: 10px !important;
    overflow: hidden !important;
    display: flex;
    justify-content: space-between;
    position: relative;
    isolation: isolate;

    &.active {
        border: 2px solid #f66700;
        overflow: visible !important;
    }

    @media (max-width: ${MOBILE}) {
        flex-direction: column;
    }
`;

/* ── Left panel (filter rows) ── */
export const FilterListLeft = styled.div`
    width: 100%;
    display: inline-flex;
    height: 100%;
    padding: 15px;
    background: white;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    flex-direction: column;

    @media (max-width: ${MOBILE}) {
        border-radius: 10px 10px 0 0;
        padding: 12px;
    }
`;

/* ── Right panel (operator) ── */
export const FilterListRight = styled.div`
    display: inline-flex;
    min-height: 100%;
    background: #f8f8f8;
    min-width: 220px;
    padding: 15px;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    align-items: flex-start;

    @media (max-width: ${MOBILE}) {
        min-width: 100%;
        width: 100%;
        border-radius: 0 0 10px 10px;
        padding: 12px;
        border-top: 1px solid #eeeeee;
    }
`;

/* ── Single filter row item ── */
export const FilterListItem = styled.div`
    display: inline-flex;
    width: 100%;

    .row {
        width: 100%;
    }
`;

/* ── Delete icon column ── */
export const DeleteCol = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-left: auto;
`;

/* ── Save Changes button ── */
export const SaveButtonWrapper = styled.div`
    position: absolute;
    right: 15px;
    bottom: -18px;
    z-index: 1;

    @media (max-width: ${MOBILE}) {
        position: static;
        width: 100%;
        margin-top: 12px;
    }
`;

export const SaveButton = styled(Button)`
    && {
        @media (max-width: ${MOBILE}) {
            width: 100%;
        }
    }
`;

/* ── No filters text ── */
export const NoFiltersText = styled.span`
    display: block;
    padding: 8px 0;
    color: #000000;
    opacity: 0.2;
    font-weight: 600;
`;

/* ── Mobile responsive overrides for the Bootstrap row/col grid ── */
export const MobileFilterRow = styled.div`
    /* On mobile: stack filter fields vertically */
    @media (max-width: ${MOBILE}) {
        .row {
            flex-direction: column !important;
        }

        .row > div[class*="col-"] {
            width: 100% !important;
            max-width: 100% !important;
            flex: 0 0 100% !important;
            padding-left: 0 !important;
            padding-right: 0 !important;
            margin-bottom: 10px;
        }

        .row > div[class*="col-"]:last-child {
            margin-bottom: 0;
        }
    }
`;
